/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";
// import moment from "moment";

import io from "socket.io-client";
import { toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

// import { values, difference, differenceBy } from "lodash";

// import {
//   COMMUNITY_CHAT,
//   MESSAGE_SENT,
//   MESSAGE_RECIEVED,
//   TYPING,
//   PRIVATE_MESSAGE,
//   USER_CONNECTED,
//   USER_DISCONNECTED,
//   NEW_CHAT_USER,
// } from "../../Events";

//const socketUrl = "http://58.226.94.199:3231"
const socketUrl = "https://api.aniplustv.com:3232";

class ChatHead extends Component {
  state = {
    chatUserCount: 0,
    chatOn: true,
  };
  _isMounted = false;

  componentDidMount = () => {
    this._isMounted = true;

    this.initSocket();
  };
  initSocket = () => {
    const socket = io(socketUrl);
    ////console.log('client connect.')
    if (this._isMounted) {
      socket.emit("userCount", () => {});
      socket.on("getUserCount", (users) => {
        ////console.log(users)
        ////console.log(Object.keys(users).length)
        this.setState({
          chatUserCount: Object.keys(users).length,
        });
      });
    }
  };

  _onChatIn = (chatOn) => {
    //console.log('====>')
    //console.log(chatOn)

    const { onChatChange, logout, connect, intReturn } = this.props.childProps;
    if (intReturn === 0) {
      if (connect === "Y") {
      } else {
        onChatChange(chatOn);
        if (chatOn) {
          logout();
        }
      }
    } else {
      toast.warn("채팅은 멤버십 가입후 이용이 가능합니다.");
    }

    /*
        const { intReturn, chatOn } = this.props.childProps;
        const { loginId } = this.props;

        if(loginId === '' || loginId === null || loginId === undefined) {

        } else {
            if(intReturn === 0) {
                this.setState({
                    chatOn: !chatOn
                })
            }
        }
        */
  };

  render() {
    const { chatUserCount } = this.state;
    // const { loginId } = this.props;
    const { intReturn, chatOn, connect } = this.props.childProps;
    return (
      <Fragment>
        <h1>
          채팅<span>{chatUserCount}명</span>
          <em>
            <img src="/img/live_img/efresh_img.png" />
          </em>
          <strong
            onClick={() => this._onChatIn(chatOn)}
            className={
              intReturn === 0
                ? chatOn
                  ? connect === "N"
                    ? "on"
                    : null
                  : null
                : null
            }
          >
            {intReturn === 0
              ? chatOn
                ? connect === "N"
                  ? "ON"
                  : "OFF"
                : "OFF"
              : "OFF"}
          </strong>
        </h1>

        {/*            
                <ToastContainer 
                    position="bottom-right"
                    hideProgressBar
                />
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(ChatHead));
